// 参加ユーザー一覧（アバター付き）。PO Board の epic-presence-badges に近い構造。
// 実装フェーズでは MEIDEN CONNECT の avatar URL or 自動生成イニシャル画像で描画する。

interface Viewer {
  readonly userId: string;
  readonly displayName: string;
  readonly avatarImageUrl?: string | undefined;
  readonly color: string;
}

interface Props {
  readonly viewers: readonly Viewer[];
  readonly maxVisible?: number | undefined;
}

export function PresenceBadges({ viewers, maxVisible = 4 }: Props): JSX.Element {
  const visible = viewers.slice(0, maxVisible);
  const overflow = viewers.length - visible.length;

  return (
    <div
      role="list"
      aria-label="参加ユーザー一覧"
      style={{
        display: "flex",
        gap: "-8px",
        padding: "4px",
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        borderRadius: "9999px",
        boxShadow: "var(--shadow-1)",
      }}
    >
      {visible.length === 0 ? (
        <span style={{ padding: "4px 12px", fontSize: "12px", color: "var(--color-text-muted)" }}>
          自分のみ
        </span>
      ) : (
        visible.map((v, i) => (
          <div
            key={v.userId}
            role="listitem"
            title={v.displayName}
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              border: `2px solid ${v.color}`,
              marginLeft: i === 0 ? 0 : "-8px",
              background: v.avatarImageUrl
                ? `url(${v.avatarImageUrl}) center/cover`
                : "var(--color-surface-muted)",
              display: "grid",
              placeItems: "center",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            {v.avatarImageUrl ? null : v.displayName.charAt(0)}
          </div>
        ))
      )}
      {overflow > 0 ? (
        <div
          aria-label={`さらに ${overflow} 人`}
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            background: "var(--color-surface-muted)",
            display: "grid",
            placeItems: "center",
            fontSize: "11px",
            marginLeft: "-8px",
          }}
        >
          +{overflow}
        </div>
      ) : null}
    </div>
  );
}
